import { useEffect, useState } from 'react';
import { TasteBar } from '../ui/taste-bar';

interface Props {
  acid: number;
  bitter: number;
  body: number;
  productId: number;
}

export function TasteProfile({ acid, bitter, body, productId }: Props) {
  const [filled, setFilled] = useState(false);

  // biome-ignore lint/correctness/useExhaustiveDependencies: productId intentionally keys the restart so navigating to a different product replays the animation.
  useEffect(() => {
    setFilled(false);
    const timer = setTimeout(() => setFilled(true), 120);
    return () => clearTimeout(timer);
  }, [productId]);

  const scales = [
    { label: 'Кислинка', value: acid },
    { label: 'Гірчинка', value: bitter },
    { label: 'Тіло', value: body },
  ];

  return (
    <div className="space-y-4">
      {scales.map((scale) => (
        <TasteBar
          key={scale.label}
          label={scale.label}
          value={scale.value}
          fill={filled ? scale.value : 0}
          height={4}
          animated
          showValue
        />
      ))}
    </div>
  );
}
